module.exports = __webpack_public_path__ + "img/SOFTWARE_DT.f2b7d8d3.png";